import { Image } from '../../DocumentCapture.helpers';
import type { Input } from '../pages/uploadImageReducer.types';
import { documentNeedsReupload } from '../UploadDocuments.selectors';

export const doInputsContainBlurryImages = (inputs: Input[]) => inputs.some((input) => input.isSharp === false);
export const doInputsContainReuploadRequests = (inputs: Input[]) => inputs.some(documentNeedsReupload);
export const doSomeInputsContainUrls = (inputs: Input[]) => inputs.some((input) => input.url);
export const doAllInputsContainUrls = (inputs: Input[]) => inputs.every((input) => input.url);

export const getMissingOrNextPageNumber = (inputs: Input[]) => {
  const maxPageNumber = Math.max(...inputs.map((input) => input.pageNumber ?? 0));

  const existingPageNumbers = new Set(inputs.map((input) => input.pageNumber));
  const pageNumberSeries = Array.from(Array(maxPageNumber).keys()).map((index) => index + 1);

  const nextPageNumber = maxPageNumber + 1;
  for (const pageNumber of pageNumberSeries) {
    if (existingPageNumbers.has(pageNumber)) {
      continue;
    }

    return pageNumber;
  }

  return nextPageNumber;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getImagesFromInputs = (inputs: Input[]) => inputs.map(({ label, name, touched, ...input }) => ({
  ...input,
  actions: input.actions ?? {},
})) as Image[];

export const getUploadedImagesFromInputs = (inputs: Input[]) => inputs.filter((input) => input.documentId);

export const calculateIsProgressStateSyncNeeded = (previousInputs: Input[], inputs: Input[]) => {
  const hasUploadedOrDeletedImages = getUploadedImagesFromInputs(previousInputs).length
      !== getUploadedImagesFromInputs(inputs).length;

  if (hasUploadedOrDeletedImages) {
    return true;
  }

  const documentIdToUrlMapping = new Map(previousInputs.map((input) => [input.documentId, input.url]));

  for (const input of inputs) {
    if (documentIdToUrlMapping.get(input.documentId) !== input.url) {
      return true;
    }
  }

  return false;
};
